const KNOWN_EVENT_LABEL_KEYS: Record<string, string> = {
  session_started: 'platformUsage.events.sessionStarted',
  session_heartbeat: 'platformUsage.events.sessionHeartbeat',
  session_ended: 'platformUsage.events.sessionEnded',
  page_view: 'platformUsage.events.pageView',
  module_opened: 'platformUsage.events.moduleOpened',
  action_performed: 'platformUsage.events.actionPerformed',
};

export function isKnownPlatformUsageEvent(eventType: string): boolean {
  return eventType in KNOWN_EVENT_LABEL_KEYS;
}

export function platformUsageEventLabelKey(eventType: string): string {
  return KNOWN_EVENT_LABEL_KEYS[eventType] ?? 'platformUsage.events.unknown';
}
